module.exports = __webpack_public_path__ + "static/1_1_defineai_IT-3108ccf6c806bc16f070f4fcab0e7702.svg";